/* Grasmaaier-keuzehulp (concept 2026-10-28). Vanilla JS, mapping in snippets/grasmaaier-keuzehulp-mapping.liquid. */
(function () {
  var root = document.querySelector('[data-gk-keuzehulp]'); if (!root) return;
  var M; try { M = JSON.parse(root.querySelector('script[data-gk-mapping]').textContent); } catch (e) { return; }
  var T = M.texts, Q = M.questions, stage = root.querySelector('[data-gk-stage]'), bar = root.querySelector('[data-gk-progress]'),
    lbl = root.querySelector('[data-gk-progress-label]'), live = root.querySelector('[data-gk-live]'), A = {}, step = 0, PD = {};
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function prog() {
    var n = Q.length, done = step >= n;
    bar.style.width = (done ? 100 : Math.round(step / n * 100)) + '%';
    lbl.textContent = done ? 'Jouw advies' : 'Vraag ' + (step + 1) + ' van ' + n;
  }
  function focusTop() { var h = stage.querySelector('h2,legend'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function renderQ() {
    prog(); var q = Q[step], h = '<fieldset class="gk-q"><legend class="gk-qh">' + esc(q.title) + '</legend>';
    if (q.help) h += '<p class="gk-help">' + esc(q.help) + '</p>';
    h += '<div class="gk-opts">';
    q.opts.forEach(function (o) {
      var id = 'gk-' + q.id + '-' + o[0];
      h += '<label class="gk-opt' + (A[q.id] === o[0] ? ' is-on' : '') + '" for="' + id + '"><input type="radio" name="gk-' + q.id + '" id="' + id + '" value="' + esc(o[0]) + '"' + (A[q.id] === o[0] ? ' checked' : '') + '><span><strong>' + esc(o[1]) + '</strong>' + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</span></label>';
    });
    h += '</div><div class="gk-nav">' + (step > 0 ? '<button type="button" class="button button--secondary" data-gk-back>' + esc(T.back) + '</button>' : '<span></span>') +
      '<button type="button" class="button" data-gk-next' + (A[q.id] ? '' : ' disabled') + '>' + esc(step === Q.length - 1 ? T.result_btn : T.next) + '</button></div></fieldset>';
    stage.innerHTML = h;
    stage.querySelectorAll('input').forEach(function (i) {
      i.addEventListener('change', function () {
        A[q.id] = i.value; stage.querySelectorAll('.gk-opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(i)); });
        stage.querySelector('[data-gk-next]').disabled = false;
        setTimeout(function () { if (A[q.id] === i.value) next(); }, 250);
      });
    });
    var b = stage.querySelector('[data-gk-back]'); if (b) b.addEventListener('click', function () { step--; renderQ(); focusTop(); });
    stage.querySelector('[data-gk-next]').addEventListener('click', next);
  }
  function next() { var q = Q[step]; if (!A[q.id]) return; step++; if (step >= Q.length) result(); else { renderQ(); focusTop(); } }
  function test(v, op, x) { return op === 'lt' ? v < x : op === 'gt' ? v > x : op === 'gte' ? v >= x : op === 'lte' ? v <= x : op === 'ne' ? v !== x : v === x; }
  function score() {
    var out = [];
    Object.keys(M.models).forEach(function (k) {
      var m = M.models[k], s = 0, ok = true;
      Q.forEach(function (q) {
        var o = q.opts.find(function (x) { return x[0] === A[q.id]; }); if (!o) return;
        (o[3] || []).forEach(function (r) { if (test(m.a[r.attr], r.op, r.val)) { if (r.w <= -99) ok = false; else s += r.w; } });
      });
      if (ok) out.push({ m: m, s: s });
    });
    return out.sort(function (a, b) { return b.s - a.s || a.m.a.price - b.m.a.price; });
  }
  function load(list) {
    return Promise.all(list.map(function (x) {
      var h = x.m.handle; if (PD[h]) return null;
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) { PD[h] = { available: false }; return; }
        var v = p.variants.find(function (z) { return z.available; }) || p.variants[0];
        PD[h] = { title: p.title, url: '/products/' + p.handle, available: !!(p.available && v.available), price: v.price, vid: v.id, img: p.featured_image };
      }).catch(function () { PD[h] = { available: false }; });
    }));
  }
  function card(x, main) {
    var p = PD[x.m.handle], img = p.img ? '<img src="' + esc(p.img) + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy" width="200" height="200">' : '';
    return '<article class="gk-card' + (main ? ' gk-main' : '') + '">' + (main ? '<p class="gk-badge">' + esc(T.badge) + '</p>' : '') +
      '<a href="' + esc(p.url) + '" class="gk-img">' + img + '</a><div class="gk-body"><h3 class="gk-name"><a href="' + esc(p.url) + '">' + esc(x.m.name) + '</a></h3>' +
      '<p class="gk-price">' + money(p.price) + '</p><ul class="gk-facts">' + x.m.facts.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>' +
      '<div class="gk-btns"><a class="button button--secondary" href="' + esc(p.url) + '">' + esc(T.view) + '</a><button type="button" class="button" data-gk-add="' + p.vid + '">' + esc(T.add) + '</button></div></div></article>';
  }
  function result() {
    prog(); stage.innerHTML = '<p>Advies wordt samengesteld…</p>';
    var list = score().slice(0, 12);
    load(list).then(function () {
      var av = list.filter(function (x) { return PD[x.m.handle] && PD[x.m.handle].available; }), h = '';
      var edit = '<div class="gk-nav"><button type="button" class="button button--secondary" data-gk-back>' + esc(T.back) + '</button><button type="button" class="button button--tertiary" data-gk-restart>' + esc(T.restart) + '</button></div>';
      if (!av.length) h = '<h2 class="gk-qh">' + esc(T.none_h) + '</h2><p>' + esc(T.none_text) + '</p>' + edit;
      else {
        h = '<h2 class="gk-qh">' + esc(T.result_h) + '</h2><p class="gk-help">' + esc(T.result_sub) + '</p>' + card(av[0], true);
        var alt = av.slice(1, 1 + (M.max_alternatives || 2));
        if (alt.length) h += '<h3 class="gk-alt-h">' + esc(T.alt_h) + '</h3><div class="gk-alts">' + alt.map(function (x) { return card(x, false); }).join('') + '</div>';
        h += '<p class="gk-note">' + esc(T.price_note) + '</p><p class="gk-contact">' + T.contact_html + '</p>' + edit;
      }
      stage.innerHTML = h; live.textContent = av.length ? T.result_h : T.none_h; focusTop();
      stage.querySelector('[data-gk-back]').addEventListener('click', function () { step = Q.length - 1; renderQ(); });
      stage.querySelector('[data-gk-restart]').addEventListener('click', function () { A = {}; step = 0; renderQ(); focusTop(); });
      stage.querySelectorAll('[data-gk-add]').forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: +b.getAttribute('data-gk-add'), quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw 0; b.textContent = T.added; live.textContent = T.added; document.dispatchEvent(new CustomEvent('cart:refresh')); })
            .catch(function () { b.disabled = false; });
        });
      });
    });
  }
  renderQ();
})();
